// Mega Menu
// var listItem = document.querySelector('.HorizontalList__Item');
// var listItem = document.getElementsByClassName('HorizontalList__Item');
// console.log('menus...', listItem)

// $(document).ready(function(){
//   var listItem = $('.HorizontalList__Item[aria-haspopup=true]');
//   // var megaMenu = listItem.children( '.MegaMenu' );
//   listItem.mouseenter(
//     function(e){
//       $(e.target).addClass('is-expanded');
//       // console.log('he..', $(e.target).children( '.MegaMenu' ) )
//       $(e.target).children( '.MegaMenu' ).attr('aria-hidden', 'false');
//     }
//   )

//   listItem.on( "mouseleave", (
//     function(e){
//       $(e.target).removeClass('is-expanded');
//       // console.log('he..', $(e.target).children( '.MegaMenu' ) )
//       $(e.target).children( '.MegaMenu' ).attr('aria-hidden', 'true');
//     }
//   )

// })

// (function($){
//   var $ = jQuery = $;

//   var listItem = $('.HorizontalList__Item')
  
//   console.log('aaaa' ,listItem)

// });
// listItem.addEventListener('', e => {
//   e.classList.add('is-expanded');
//   console.log('e.',  e)
// });

// fastdom.mutate(function () {
//   event.target.setAttribute('aria-hidden', 'false');

//   if (listItem) {
//     listItem.classList.add('is-expanded');

//     getSiblings(listItem, '.is-expanded').forEach(function (item) {
//       item.classList.remove('is-expanded');
//     });
//   }

//   _this50.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

$(document).ready(function(){
  $(document).on('click', '#slidecarthq .slidecarthq.right header button, .slidecarthq-overlay.open', function(){
    $('html, body').removeClass('js-drawer-open');
  });
});
